angular.module('CarsSaraBo').directive('chars', ['$timeout', function ($timeout) {
    'use strict';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, $elem, attrs, $ctrl) {

            var regReplace,
                preset = {
                    'only-numbers': '0-9',
                    'numbers': '0-9\\s',
                    'only-letters': 'A-Za-z',
                    'letters': 'A-Za-z\\s',
                    'email': '\\wÑñ@._\\-',
                    'alpha-numeric': '\\w\\s',
                    'latin-alpha-numeric': '\\w\\sÑñáéíóúüÁÉÍÓÚÜ´¨'
                },
                filter = preset[attrs.chars] || attrs.chars;

            $elem.on('input keyup change', function () {

                var val = $elem.val().toString();

                regReplace = new RegExp('[^' + filter + ']', 'ig');
                $ctrl.$setViewValue(val.replace(regReplace, ''));
                $timeout(function () {

                    $ctrl.$render();

                });

            });

        }
    };

}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/characters_directive.js
// module id = 873
// module chunks = 3